/**
 * Contextual Tip Definitions
 *
 * One-time tooltips shown at key moments during the user's first days.
 * Each tip fires once and is persisted in AsyncStorage.
 */

export interface TipDefinition {
  id: string;
  /** i18n key for the tip message */
  messageKey: string;
  /** Where to position the tooltip relative to the trigger */
  position: 'above' | 'below' | 'inline';
  /** Auto-dismiss delay in milliseconds */
  autoDismissMs: number;
  /** Whether this tip should only show once (always true for now) */
  showOnce: boolean;
}

export const TIP_DEFINITIONS: Record<string, TipDefinition> = {
  tip_first_attach: {
    id: 'tip_first_attach',
    messageKey: 'tips.firstAttach',
    position: 'above',
    autoDismissMs: 10000,
    showOnce: true,
  },
  tip_first_analysis_done: {
    id: 'tip_first_analysis_done',
    messageKey: 'tips.firstAnalysisDone',
    position: 'above',
    autoDismissMs: 10000,
    showOnce: true,
  },
  tip_new_transcript_reminder: {
    id: 'tip_new_transcript_reminder',
    messageKey: 'tips.newTranscriptReminder',
    position: 'above',
    autoDismissMs: 10000,
    showOnce: true,
  },
  tip_credit_low: {
    id: 'tip_credit_low',
    messageKey: 'tips.creditLow',
    position: 'below',
    autoDismissMs: 10000,
    showOnce: true,
  },
  tip_pdf_export: {
    id: 'tip_pdf_export',
    messageKey: 'tips.pdfExport',
    position: 'above',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_icf_progress: {
    id: 'tip_icf_progress',
    messageKey: 'tips.icfProgress',
    position: 'above',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_practice_exam: {
    id: 'tip_practice_exam',
    messageKey: 'tips.practiceExam',
    position: 'above',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_voice_recording: {
    id: 'tip_voice_recording',
    messageKey: 'tips.voiceRecording',
    position: 'above',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_documents_rag: {
    id: 'tip_documents_rag',
    messageKey: 'tips.documentsRag',
    position: 'above',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_meeting_feedback: {
    id: 'tip_meeting_feedback',
    messageKey: 'tips.meetingFeedback',
    position: 'inline',
    autoDismissMs: 12000,
    showOnce: true,
  },
  tip_mentor_training: {
    id: 'tip_mentor_training',
    messageKey: 'tips.mentorTraining',
    position: 'inline',
    autoDismissMs: 12000,
    showOnce: true,
  },
};

export function getTipDefinition(tipId: string): TipDefinition | undefined {
  return TIP_DEFINITIONS[tipId];
}
